import CutOffTime from '@/pages/GeneralSettings/components/DateAndTime/CutOffTime';
import { memo } from 'react';
import BlackoutDate from './BlackoutDate';
import TimeZone from './TimeZone';
import CalculationDeliveryMethod from '@/pages/GeneralSettings/components/DateAndTime/CalculationDeliveryMethod';

const DateAndTime = () => {
  return (
    <div className="date-and-time-container d-flex flex-column">
      <CalculationDeliveryMethod />

      <CutOffTime />

      <TimeZone />

      <BlackoutDate />
    </div>
  );
};

export default memo(DateAndTime);
